const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  // 推广合伙人
  agentInfoLoaded: state => state.agent.loaded,
  isAgent: state => state.agent.isAgent,
  agentSwitchOn: state => state.agent.switchOn,
  agentMaxRatio: state => state.agent.maxRatio,
  agentSubCount: state => state.agent.subCount
}
export default getters
